import { useCallback } from 'react'

import { useApiQueryClient } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useInvalidateInvoice = () => {
  const queryClient = useApiQueryClient()

  const invalidateInvoice = useCallback(() => {
    queryClient.invalidateQueries(dashboardv99990101Client.getAllLineItems)
    queryClient.invalidateQueries(dashboardv99990101Client.getAllLineItemGroups)
    queryClient.invalidateQueries(dashboardv99990101Client.getInvoice)
  }, [queryClient.invalidateQueries])

  return invalidateInvoice
}
